import { render, staticRenderFns } from "./MetodosPagoCRUD.vue?vue&type=template&id=39a23d06"
import script from "./MetodosPagoCRUD.vue?vue&type=script&lang=js"
export * from "./MetodosPagoCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports